import { getHardcodedUiLocale } from '../shared/hardcodedKoEn';
import names from './upbitEnglishNames.json';

const byMarket = names.byMarket as Record<string, string>;
const byKorean = names.byKorean as Record<string, string>;
const byTicker = names.byTicker as Record<string, string>;

function tickerFromSymbol(symbol?: string | null, perp?: string | null): string | null {
  const sym = (symbol || '').trim().toUpperCase();
  if (sym.startsWith('KRW-')) return sym.slice(4) || null;
  if (sym.includes('-')) {
    const parts = sym.split('-');
    return parts[parts.length - 1] || null;
  }
  const p = (perp || '').trim().toUpperCase();
  if (p.endsWith('USDT')) return p.slice(0, -4) || null;
  return null;
}

/** Formal English coin name for /en · /fr. KR keeps kr_name.
 *
 *  byMarket/byKorean = Upbit markets. byTicker = Upbit + CoinGecko bulk
 *  (Binance-spot tickers, unique symbols, bracket-gap fill) + curated rows.
 *  Still missing = obscure/delisted ticker with no CG id → show ticker.
 */
export function displayCoinName(opts: {
  kr_name?: string | null;
  symbol?: string | null;
  perp?: string | null;
  locale?: string;
}): string {
  const locale = opts.locale ?? getHardcodedUiLocale();
  const kr = (opts.kr_name || '').trim();
  if (locale === 'kr') {
    return kr || opts.symbol || opts.perp || '–';
  }
  const sym = (opts.symbol || '').trim().toUpperCase();
  if (sym && byMarket[sym]) return byMarket[sym];
  if (kr && byKorean[kr]) return byKorean[kr];
  const ticker = tickerFromSymbol(opts.symbol, opts.perp);
  if (ticker && byTicker[ticker]) return byTicker[ticker];
  // Already Latin formal name / ticker — keep as-is
  if (kr && !/[\uac00-\ud7a3]/.test(kr)) return kr;
  return ticker || opts.symbol || opts.perp || '–';
}
